import { SilverwareForkKnifeIcon } from './SilverwareForkKnifeIcon';

/**
 * author: Google
 * id C3D19BD6-D474-4F86-94AA-1A4B04FE8E3A
 * name silverware-fork-knife
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-fork-knife.svg
 * tags
 * - Food / Drink 
 */
export const PlaceSettingIcon = SilverwareForkKnifeIcon;
export default PlaceSettingIcon